<template>
    <div>
        <a-card size="small" title="模板管理">
            <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>
            <!-- 文档列表 -->
            <a-table  :columns="columns" :data-source="tableData" 
                :pagination="false" :loading="tloading" rowKey="id" size="middle" :scroll="{ x: clientWidth}">
                <template slot="operation" slot-scope="text, record">
                    <router-link class="tableLink"  :to="{path:'edittemp',query: {id: record.id,}}">编辑</router-link>
                    <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                        <a class="tableLink"  href="javascript:;">删除</a>
                    </a-popconfirm>
                </template>
            </a-table>
        </a-card>
        

    </div>
</template>
<script>

const columns = [
    
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            return  index + 1;
        }
    },
    {
        title: "标题",
        dataIndex: "title",
        align: "center",
        width:120
    },
    {
        title: "描述",
        dataIndex: "desc",
        align: "center",
        width:120
    },
    {
        title: "更新人",
        dataIndex: "updatetuser",
        width:100
    },
    {
        title: "更新时间",
        dataIndex: "updatetime",
        width:150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 90,
        scopedSlots: { customRender: 'operation' },
    },

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
        };
    },
    methods: {
        handleNew(){
            this.$router.push({
                path: "addtemp",
                query: {
                    id:'',
                }
            });
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "mcmsmanager/deletechannel",
                params: {id: item.id}
            }).then((res) => {
                if (res.status == '200') {
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                menucode:'templete',
                urlparams:false
            };
            that.$store.dispatch({
                type: "open/selectdoclist",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    this.tableData = res.data.data;
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
 
    },
    components:{
        
    },
    mounted(){
        this.getAppSumData()
    },
};
</script>
<style scoped>
   
    .tableLink{
        margin-right: 10px;
    }

</style>

